import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface Props {
  isClose: () => void;
  imgList: string[];
}

const ImageModal = ({ isClose, imgList }: Props) => {
  const [currentpage, setCurrentPage] = useState(1);
  const sliderRef = useRef<Slider>(null);

  const settings = {
    centerMode: true,
    infinite: true,
    centerPadding: '0',
    slidesToShow: 1,
    speed: 500,
    initialSlide: 0,
    afterChange: (current: number) => setCurrentPage(current + 1),
  };

  return (
    <Wrapper>
      <Header>
        <Icon onClick={isClose}>
          <img
            src="/assets/images/close/close-white.svg"
            alt="close"
            width={24}
            height={24}
          />
        </Icon>
        <PageNumber>
          {currentpage} / {imgList.length}
        </PageNumber>
        <Spacer />
      </Header>
      <SlideContainer>
        <Slider ref={sliderRef} {...settings}>
          {imgList.map((img, index) => (
            <div key={index}>
              <img src={img} alt={`Slide ${index + 1}`} />
            </div>
          ))}
        </Slider>
      </SlideContainer>
    </Wrapper>
  );
};

export default ImageModal;

interface ButtonProps {
  screenWidth: number;
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3000;
  background-color: #000;
  display: flex;
  flex-direction: column;
  /* justify-content: flex-start;
  align-items: center; */
`;

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 2px;
  z-index: 10;
`;

const Icon = styled.button`
  display: flex;
  padding: 10px;
  align-items: center;
  border: none;
  background-color: transparent;
`;

const PageNumber = styled.div`
  flex: 1;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%; /* 23.2px */
  letter-spacing: -0.32px;
`;

const Spacer = styled.div`
  width: 44px;
`;

const SlideContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  .slick-slider {
    width: 100%;
    display: flex;
  }

  .slick-slide > div {
    height: 100vh;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  img {
    max-height: 100vh;
    width: 100%;
    object-fit: cover;
  }
`;
